import { AddCircleOutline as AddCircleOutlineIcon, Delete as DeleteIcon, RemoveCircleOutline as RemoveCircleOutlineIcon, RemoveShoppingCart as RemoveShoppingCartIcon, ShoppingCart as ShoppingCartIcon } from '@mui/icons-material'
import { Avatar, Box, Button, Card, CardActions, Container, Dialog, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Link, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, MenuItem, Radio, RadioGroup, TextField, Tooltip, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import Big from 'big.js'
import _ from 'lodash'
import React from 'react'
import { Link as RouterLink, withRouter } from "react-router-dom"
import SharedUtilities from '../../shared/classes/SharedUtilities'
import Utilities from '../classes/Utilities'
import { AddressForm, CreditCardFrame, GuestForm, Heading } from '../components'
import { withAppContext } from '../context/AppContextProvider'

const styles = (theme) => ({
    loading: {
        marginTop: theme.spacing(2),
    },
    dialogText: {
        padding: theme.spacing(2),
    },
    listItemText: {
        paddingRight: 78,
    },
    box: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    marginAbove: {
        marginTop: theme.spacing(2),
    },
    cartContentsCard: {
        marginTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    guestInfoCard: {
        marginTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    shippingInfoCard: {
        marginTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    shippingAddressForm: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    shippingAddressSubmit: {
        margin: theme.spacing(3, 0, 2),
    },
    paymentInfoCard: {
        marginTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    submitOrderCard: {
        marginTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    totalsGrid: {
        marginTop: theme.spacing(2),
    },
    radioGroup: {
        marginTop: theme.spacing(1),
    },
    nested: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    sumListItemText: {
        flex: 'none',
    },
    cardActions: {
        justifyContent: "space-between",
        padding: 0,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
})

class Cart extends React.Component {
    contentsCardRef = React.createRef()
    guestInfoCardRef = React.createRef()
    shippingCardRef = React.createRef()
    shippingAddressFormRef = React.createRef()
    paymentCardRef = React.createRef()
    submitCardRef = React.createRef()
    extraFieldsFormRef = React.createRef()

    state = {
        gettingPostage: false,
        guestFormFilled: false,
        guestInfo: {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            street1: '',
            street2: '',
            city: '',
            state: '',
            zip: '',
        },
        regionalTaxes: null,
        shippingMethod: null,
        postage: null,
        paymentMethod: null,
        paymentCofId: this.props.cart.activeCard ? this.props.cart.activeCard.id : null,
        paymentToken: null,
        paymentExpiry: null,
        paymentLast4: null,
        paymentType: null,
        paymentExtraData: null,
        paymentSaveCard: true,
        note: '',
        submitting: false,
    }

    async componentDidMount() {
        const { socket, features, user, cart } = this.props

        this.unbindCartUpdate = socket.on('cartUpdate', this.handleCartUpdate)

        if (features.zipcode_based_taxation && !user.isGuest && cart.customer?.postal) {
            const regionalTaxes = await socket.send('order', {
                step: 'getTaxByZipcode',
                zipcode: cart.customer.postal,
            })

            this.setState({
                regionalTaxes,
            })
        }
    }

    componentWillUnmount() {
        this.unbindCartUpdate()
    }

    resetGuestInfo = async () => {
        this.setState({
            guestFormFilled: false,
            guestInfo: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                street1: '',
                street2: '',
                city: '',
                state: '',
                zip: '',
            },
            regionalTaxes: null,
        })
    }

    resetShipping = async () => {
        this.setState({
            shippingMethod: null,
            postage: null,
        })
    }

    resetPayment = async () => {
        this.setState({
            paymentMethod: null,
            paymentCofId: this.props.cart.activeCard ? this.props.cart.activeCard.id : null,
            paymentToken: null,
            paymentExpiry: null,
            paymentLast4: null,
            paymentType: null,
            paymentExtraData: null,
            paymentSaveCard: true,
        })
    }

    isSubmittable = () => {
        const { user, cart } = this.props
        const { shippingMethod, postage, paymentMethod, paymentToken, paymentCofId } = this.state

        // no shipping method chosen
        if (!shippingMethod) {
            return false
        }

        // rules for everyone but employees
        if (!user.isEmployee) {
            // no shipping service/rate chosen
            if (shippingMethod == 'ship' && !postage?.rate) {
                return false
            }

            // no payment method chosen and not an employee
            if (!paymentMethod) {
                return false
            }

            // no payment method chosen and package in cart
            if (!paymentMethod && cart.contents.some(item => item.type == 'package')) {
                return false
            }

            // credit card information not provided
            if (paymentMethod == 'credit' && !paymentToken) {
                return false
            }

            // card-on-file not chosen
            if (paymentMethod == 'cof' && !paymentCofId) {
                return false
            }
        }

        return true
    }

    handleCartUpdate = async () => {
        this.setState({
            postage: null,
        })
    }

    handleDeleteItem = async (item) => {
        try {
            const response = await this.props.socket.send('order', {
                step: 'modifyItemInCart',
                type: item.type,
                itemId: item.itemId,
                bulk: item.bulk,
                newQuantity: 0,
            })

            this.props.showMessage(response, {
                autoHideDuration: 3000,
            })

        } catch (err) {
            this.props.showError(err)
        }
    }

    handleChangeQty = async (item, newQuantity) => {
        try {
            const response = await this.props.socket.send('order', {
                step: 'modifyItemInCart',
                type: item.type,
                itemId: item.itemId,
                bulk: item.bulk,
                newQuantity,
            })

            this.props.showMessage(response, {
                autoHideDuration: 3000,
            })

        } catch (err) {
            this.props.showError(err)
        }
    }

    handleEmptyCart = async () => {
        try {
            const response = await this.props.socket.send('order', {
                step: 'emptyCart',
            })

            this.props.showMessage(response, {
                autoHideDuration: 3000,
            })

        } catch (err) {
            this.props.showError(err)
        }
    }

    handleGuestFormInput = (event) => {
        event.preventDefault()

        this.resetGuestInfo()
        this.resetPayment()
        this.resetShipping()
    }

    handleGuestFormSubmit = async (event) => {
        event.preventDefault()

        try {
            const guestInfo = Utilities.getFormValues(event.target)

            this.setState({
                guestFormFilled: true,
                guestInfo,
            })

            this.resetShipping()
            this.resetPayment()

            if (this.props.features.zipcode_based_taxation) {
                const regionalTaxes = await this.props.socket.send('order', {
                    step: 'getTaxByZipcode',
                    zipcode: guestInfo.zip,
                })

                this.setState({
                    regionalTaxes,
                })
            }

            this.shippingCardRef.current?.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' })

        } catch (err) {
            this.props.showError(err)
        }
    }

    handleShippingMethodChange = (event) => {
        this.resetShipping()

        this.setState({
            shippingMethod: event.target.value,
            postage: null,
        })
    }

    handleShippingAddressInput = (event) => {
        this.setState({
            postage: null,
        })
    }

    handleCheckPostageRates = async (event) => {
        event.preventDefault()

        await this.setState({
            gettingPostage: true,
        })

        try {
            const toAddress = Utilities.getFormValues(event.target)

            let postage = await this.props.socket.send('order', {
                step: 'getPostageRates',
                toAddress,
            })

            this.setState({
                postage,
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.setState({
            gettingPostage: false,
        })
    }

    handlePostageRateIdChange = async (event) => {
        const { postage } = this.state

        this.setState({
            postage: {
                ...postage,
                rate: _.flatMap(postage?.rates).find(rate => rate.id == event.target.value),
            },
        })
    }

    handlePaymentMethodChange = (event) => {
        this.resetPayment()

        this.setState({
            paymentMethod: event.target.value,
        })
    }

    handlePaymentCofIdChange = (event) => {
        this.setState({
            paymentCofId: event.target.value,
        })
    }

    handleTokenize = (paymentToken, paymentExpiry, paymentLast4, paymentType, paymentExtraData, paymentSaveCard) => {
        this.setState({
            paymentToken,
            paymentExpiry,
            paymentLast4,
            paymentType,
            paymentExtraData,
            paymentSaveCard,
        })
    }

    handlePaymentChangeCard = () => {
        this.setState({
            paymentToken: null,
            paymentExpiry: null,
            paymentLast4: null,
            paymentType: null,
            paymentExtraData: null,
        })
    }

    handleNoteChange = (event) => {
        this.setState({
            note: event.target.value,
        })
    }

    handleSubmitOrder = async () => {
        const { showMessage, showError, closeSnackbar, messageCompanion, embedOptions, socket } = this.props
        const { guestInfo, shippingMethod, postage, paymentMethod, paymentCofId, paymentToken, paymentExpiry, paymentLast4, paymentType, paymentExtraData, paymentSaveCard, note } = this.state

        // check optional extraFields for required fields
        if (this.extraFieldsFormRef?.current) {
            if (!this.extraFieldsFormRef.current.reportValidity()) {
                return
            }
        }

        await this.setState({
            submitting: true,
        })

        try {
            const response = await socket.send('order', {
                step: 'submitOrder',
                guestInfo,
                shippingMethod,
                shippingAddress: this.shippingAddressFormRef.current ? Utilities.getFormValues(this.shippingAddressFormRef.current) : null,
                postage,
                paymentMethod,
                paymentCofId: paymentMethod == 'cof' ? paymentCofId : '',
                paymentToken: paymentMethod == 'credit' ? paymentToken : '',
                paymentExpiry: paymentMethod == 'credit' ? paymentExpiry : '',
                paymentLast4: paymentMethod == 'credit' ? paymentLast4 : '',
                paymentType: paymentMethod == 'credit' ? paymentType : '',
                paymentExtraData: paymentMethod == 'credit' ? paymentExtraData : null,
                paymentSaveCard: paymentMethod == 'credit' ? paymentSaveCard : false,
                extraFields: this.extraFieldsFormRef.current ? Utilities.getFormValues(this.extraFieldsFormRef.current) : null,
                note,
            })

            showMessage(response, {
                variant: 'success',
                persist: true,
                // eslint-disable-next-line react/display-name
                action: (key) => <Button onClick={() => { closeSnackbar(key) }}>Dismiss</Button>,
            })

            if (embedOptions.orderLandingUrl) {
                messageCompanion({
                    navigateAway: embedOptions.orderLandingUrl,
                })
            }

        } catch (err) {
            showError(err)
        }

        await this.setState({
            submitting: false,
        })
    }

    render() {
        const { classes, paths, features, user, cart } = this.props
        const { guestFormFilled, guestInfo, regionalTaxes, shippingMethod, postage, paymentMethod, paymentToken, paymentLast4, paymentCofId, paymentSaveCard, gettingPostage, submitting } = this.state

        if (!cart.contents.length) {
            return (
                <Container maxWidth="sm">
                    <Heading icon={<ShoppingCartIcon />}>
                        Shopping Cart
                    </Heading>
                    <Box className={classes.marginAbove} align="center">
                        <Typography>Your cart is empty. <Link component={RouterLink} to={paths.order} underline="hover">Click here</Link> to browse our product selection.</Typography>
                    </Box>
                </Container>
            )
        }

        const cartContainsPackage = cart.contents.some(item => item.type == 'package')

        // subtotal
        let subtotal = Big(cart.subtotal)
        let subtotalFormatted = `$${subtotal.toFixed(2)}`

        // tax
        let tax = Big(0)

        if (regionalTaxes) {
            cart.contents.forEach(item => {
                tax = tax.plus(Big(item.subtotal).times(regionalTaxes.CombinedRate).div(100).round(2))
            })
        } else {
            tax = Big(cart.tax)
        }

        let taxFormatted = `$${tax.toFixed(2)}`

        // shipping
        let shipping = Big(0)

        // only add shipping fee if order doesn't qualify for free shipping
        if (shippingMethod == 'flatRateShip') {
            shipping = Big(cart.flatRateShippingFee)
        } else if (shippingMethod == 'ship' && postage?.rate) {
            const freeShipping = SharedUtilities.cartQualifiesForFreeShipping(cart, postage.rate.service)

            // only add fee if order doesn't qualify for free shipping
            if (!freeShipping) {
                shipping = Big(postage.rate.rate)
            }
        }

        let shippingFormatted = `$${shipping.toFixed(2)}`

        // total
        let total = Big(subtotal).plus(tax).plus(shipping)
        let totalFormattted = `$${total.toFixed(2)}`

        return (
            <Container maxWidth="sm">
                <Heading icon={<ShoppingCartIcon />}>
                    Shopping Cart
                </Heading>

                {/* Cart Contents */}
                <Card ref={this.contentsCardRef} className={classes.cartContentsCard}>
                    <FormControl variant="standard" className={classes.marginAbove} fullWidth>
                        <FormLabel>Cart Contents</FormLabel>
                    </FormControl>
                    <List>
                        {cart.contents.map(item => {
                            if (item.type == 'product') {
                                return (
                                    <ListItem key={`${item.type}-${item.itemId}-${item.bulk}`}>
                                        <ListItemAvatar>
                                            <Avatar src={item.image_url || window.location.origin + `/product_imgs/${item.upc}.png`} alt={item.name} />
                                        </ListItemAvatar>
                                        <ListItemText
                                            className={classes.listItemText}
                                            primary={item.name}
                                            secondary={`${item.quantity} x $${item.price}`}
                                        />
                                        <ListItemSecondaryAction>
                                            {!item.itemId.startsWith('wylie_egift_card') && <>
                                                <Tooltip disableInteractive arrow title="Add 1 more to cart">
                                                    <IconButton
                                                        edge="end"
                                                        aria-label="add"
                                                        onClick={() => this.handleChangeQty(item, '+1')}
                                                        size="large"
                                                    >
                                                        <AddCircleOutlineIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip disableInteractive arrow title="Remove 1 from cart">
                                                    <IconButton
                                                        edge="end"
                                                        aria-label="remove"
                                                        onClick={() => this.handleChangeQty(item, '-1')}
                                                        size="large"
                                                    >
                                                        <RemoveCircleOutlineIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip disableInteractive arrow title="Remove all from cart">
                                                    <IconButton
                                                        edge="end"
                                                        aria-label="delete"
                                                        onClick={() => this.handleDeleteItem(item)}
                                                        size="large"
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </>}
                                            {item.itemId.startsWith('wylie_egift_card') &&
                                                <Tooltip disableInteractive arrow title="Remove from cart">
                                                    <IconButton
                                                        edge="end"
                                                        aria-label="delete"
                                                        onClick={() => this.handleDeleteItem(item)}
                                                        size="large"
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            }
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                )
                            }

                            if (item.type == 'package') {
                                return (
                                    <ListItem key={`${item.type}-${item.itemId}`}>
                                        <ListItemAvatar>
                                            <Avatar src={item.image_url || item.name} alt={item.name} />
                                        </ListItemAvatar>
                                        <ListItemText
                                            className={classes.listItemText}
                                            primary={item.quantity > 1 ? `${item.name} x ${item.quantity}` : item.name}
                                            secondary={<>
                                                {`Package price: $${Big(item.subtotal).toFixed(2)}`}<br />
                                                {`Initial payment: $${Big(item.paidOnPurchase == item.price ? item.subtotal : item.paidOnPurchase).toFixed(2)}`}
                                            </>}
                                        />
                                        <ListItemSecondaryAction>
                                            <Tooltip disableInteractive arrow title="Add 1 more to cart">
                                                <IconButton
                                                    edge="end"
                                                    aria-label="add"
                                                    onClick={() => this.handleChangeQty(item, '+1')}
                                                    size="large"
                                                >
                                                    <AddCircleOutlineIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip disableInteractive arrow title="Remove 1 from cart">
                                                <IconButton
                                                    edge="end"
                                                    aria-label="remove"
                                                    onClick={() => this.handleChangeQty(item, '-1')}
                                                    size="large"
                                                >
                                                    <RemoveCircleOutlineIcon />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip disableInteractive arrow title="Remove all from cart">
                                                <IconButton
                                                    edge="end"
                                                    aria-label="delete"
                                                    onClick={() => this.handleDeleteItem(item)}
                                                    size="large"
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                )
                            }
                        })}
                    </List>
                </Card>

                {/* Guest Info */}
                {user.isGuest &&
                    <Card ref={this.guestInfoCardRef} className={classes.guestInfoCard}>
                        {user.isGuest &&
                            <FormControl variant="standard" className={classes.marginAbove} fullWidth>
                                <FormLabel>Your Information</FormLabel>
                                <GuestForm
                                    className={classes.marginAbove}
                                    defaults={guestInfo}
                                    onInput={this.handleGuestFormInput}
                                    onSubmit={this.handleGuestFormSubmit}
                                >
                                    {!guestFormFilled &&
                                        <Grid item container justifyContent="space-between">
                                            <Button
                                                variant="contained"
                                                onClick={this.handleEmptyCart}
                                            >
                                                Empty Cart
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                            >
                                                Continue
                                            </Button>
                                        </Grid>
                                    }
                                </GuestForm>
                            </FormControl>
                        }
                    </Card>
                }

                {/* Shipping Info */}
                {(!user.isGuest || (user.isGuest && guestFormFilled)) &&
                    <Card ref={this.shippingCardRef} className={classes.shippingInfoCard}>
                        <Box className={classes.box}>
                            <FormControl variant="standard" className={classes.marginAbove} fullWidth>
                                <FormLabel>Shipping Method</FormLabel>
                                <RadioGroup className={classes.radioGroup} value={shippingMethod} onChange={e => this.handleShippingMethodChange(e)} >
                                    {(user.isEmployee || cart.pickupEnabled) &&
                                        <FormControlLabel value="pickup" control={<Radio />} label={cart.pickupTitle || "Pickup at clinic"} />
                                    }
                                    {cart.flatRateShippingEnabled &&
                                        <FormControlLabel value="flatRateShip" disabled={cartContainsPackage} control={<Radio />} label={cart.flatRateShippingTitle?.replaceAll('SHIPPING_FEE', `$${cart.flatRateShippingFee}`) || `Ship to me ($${cart.flatRateShippingFee})`} />
                                        // TODO show tooltip if disabled due to cartContainsPackage
                                    }
                                    {shippingMethod == 'flatRateShip' &&
                                        <AddressForm
                                            innerRef={this.shippingAddressFormRef}
                                            className={classes.shippingAddressForm}
                                            excludes={{
                                                email: true,
                                            }}
                                            defaults={user.isGuest ? {
                                                name: `${guestInfo.firstName} ${guestInfo.lastName}`,
                                                phone: guestInfo.phone,
                                                street1: guestInfo.street1,
                                                street2: guestInfo.street2,
                                                city: guestInfo.city,
                                                state: guestInfo.state,
                                                zip: guestInfo.zip,
                                            } : {
                                                name: `${cart.customer.first_name || ''} ${cart.customer.last_name || ''}`,
                                                phone: user.sms || cart.customer.phone_number,
                                                street1: cart.customer.address,
                                                street2: cart.customer.address2,
                                                city: cart.customer.city,
                                                state: cart.customer.province,
                                                zip: cart.customer.postal,
                                            }}
                                            disabled={gettingPostage}
                                        />
                                    }
                                    {cart.shippingEnabled &&
                                        <FormControlLabel value="ship" disabled={cartContainsPackage} control={<Radio />} label={cart.freeShippingEnabled ? `Ship to me (free for qualifying orders over $${Big(cart.freeShippingMinSubtotal).toFixed(2)}!)` : 'Ship to me'} />
                                        // TODO show tooltip if disabled due to cartContainsPackage
                                    }
                                    {shippingMethod == 'ship' &&
                                        <AddressForm
                                            className={classes.shippingAddressForm}
                                            defaults={user.isGuest ? {
                                                name: `${guestInfo.firstName} ${guestInfo.lastName}`,
                                                email: guestInfo.email,
                                                phone: guestInfo.phone,
                                                street1: guestInfo.street1,
                                                street2: guestInfo.street2,
                                                city: guestInfo.city,
                                                state: guestInfo.state,
                                                zip: guestInfo.zip,
                                            } : {
                                                name: `${cart.customer.first_name || ''} ${cart.customer.last_name || ''}`,
                                                email: user.email,
                                                phone: user.sms || cart.customer.phone_number,
                                                street1: cart.customer.address,
                                                street2: cart.customer.address2,
                                                city: cart.customer.city,
                                                state: cart.customer.province,
                                                zip: cart.customer.postal,
                                            }}
                                            onInput={this.handleShippingAddressInput}
                                            onSubmit={this.handleCheckPostageRates}
                                            disabled={gettingPostage}
                                            submitButton={
                                                <Button
                                                    className={classes.shippingAddressSubmit}
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={gettingPostage}
                                                >
                                                    {!gettingPostage ? `Calculate Shipping` : `Please Wait...`}
                                                </Button>
                                            }
                                        />
                                    }
                                    {!gettingPostage && shippingMethod == 'ship' && postage?.messages && Object.keys(postage.messages).map(carrier => (
                                        <React.Fragment key={carrier} >
                                            <h4>{carrier}</h4>
                                            <ul>
                                                {postage.messages[carrier].map(message => <li key={message.id}>{message.message}</li>)}
                                            </ul>
                                        </React.Fragment>
                                    ))}
                                    {!gettingPostage && shippingMethod == 'ship' && postage?.rates &&
                                        <RadioGroup className={classes.nested} value={postage?.rate?.id} onChange={e => this.handlePostageRateIdChange(e)} >
                                            {Object.keys(postage.rates).map(carrier => (
                                                <React.Fragment key={carrier}>
                                                    <h4>{carrier}</h4>
                                                    {
                                                        _.sortBy(postage.rates[carrier], [rate => parseFloat(rate.rate)]).map(rate => {
                                                            let price = rate.rate

                                                            if (SharedUtilities.cartQualifiesForFreeShipping(cart, rate.service)) {
                                                                price = '0.00'
                                                            }

                                                            let label = `$${price} ${rate.currency}: ${rate.service}`

                                                            if (rate.delivery_days) {
                                                                label += ` (${rate.delivery_days} days)`
                                                            }

                                                            return (
                                                                <FormControlLabel key={rate.id} value={rate.id} control={<Radio />} label={label} />
                                                            )
                                                        })
                                                    }
                                                </React.Fragment>
                                            ))}
                                        </RadioGroup>
                                    }
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    </Card>
                }

                {/* Payment Info */}
                {(!user.isGuest || (user.isGuest && guestFormFilled)) &&
                    <Card ref={this.paymentCardRef} className={classes.paymentInfoCard}>
                        <Box className={classes.box}>
                            <FormControl variant="standard" className={classes.marginAbove} fullWidth>
                                <FormLabel>Payment Method</FormLabel>
                                <RadioGroup className={classes.radioGroup} value={paymentMethod} onChange={(e) => this.handlePaymentMethodChange(e)} >
                                    {(user.isEmployee || cart.inStorePaymentEnabled) && !user.isGuest && shippingMethod != 'ship' && shippingMethod != 'flatRateShip' &&
                                        <FormControlLabel value="pickup" disabled={cartContainsPackage} control={<Radio />} label={cart.inStorePaymentTitle || "Pay during pickup"} />
                                        // TODO show tooltip if disabled due to cartContainsPackage
                                    }
                                    {cart.onlinePaymentEnabled && !!cart.cardsOnFile.length &&
                                        <FormControlLabel value="cof" control={<Radio />} label="Saved credit card" />
                                    }
                                    {paymentMethod == 'cof' &&
                                        <RadioGroup className={classes.nested} value={paymentCofId} onChange={(e) => this.handlePaymentCofIdChange(e)} >
                                            {cart.cardsOnFile.map(card => (
                                                <FormControlLabel key={card.id} value={card.id} control={<Radio />} label={`${card.card_number} / ${card.expiry_date}`} />
                                            ))}
                                        </RadioGroup>
                                    }
                                    {cart.onlinePaymentEnabled &&
                                        <FormControlLabel value="credit" control={<Radio />} label={!cart.cardsOnFile.length ? "Credit card" : "New credit card"} disabled={!cart.processorSettings} />
                                    }
                                    {cart.onlinePaymentEnabled && paymentMethod == 'credit' &&
                                        <CreditCardFrame
                                            className={classes.nested}
                                            processor={features.payment}
                                            processorSettings={cart.processorSettings}
                                            locked={!!paymentToken}
                                            last4={paymentLast4}
                                            billTo={user.isGuest ? {
                                                name: `${guestInfo.firstName} ${guestInfo.lastName}`,
                                                email: guestInfo.email,
                                                phone: guestInfo.phone,
                                                street1: guestInfo.street1,
                                                street2: guestInfo.street2,
                                                city: guestInfo.city,
                                                state: guestInfo.state,
                                                zip: guestInfo.zip,
                                            } : {
                                                name: `${cart.customer?.first_name || ''} ${cart.customer.last_name || ''}`,
                                                email: cart.customer?.email_address,
                                                phone: cart.customer?.phone_number,
                                                street1: cart.customer?.address,
                                                street2: cart.customer?.address2,
                                                city: cart.customer?.city,
                                                state: cart.customer?.province,
                                                zip: cart.customer?.postal,
                                            }}
                                            paymentSaveCard={paymentSaveCard}
                                            forceSaveCard={false}
                                            onTokenize={this.handleTokenize}
                                            onChangeCard={this.handlePaymentChangeCard}
                                        />
                                    }
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    </Card>
                }

                {/* Totals, Note & Submit */}
                {(!user.isGuest || (user.isGuest && guestFormFilled)) &&
                    <Card ref={this.submitCardRef} className={classes.submitOrderCard}>
                        <Grid className={classes.totalsGrid} container justifyContent="space-between">
                            <ListItemText className={classes.sumListItemText} primary="Subtotal" secondary={subtotalFormatted} />
                            <ListItemText className={classes.sumListItemText} primary="Tax" secondary={taxFormatted} />
                            <ListItemText className={classes.sumListItemText} primary="Shipping" secondary={shippingFormatted} />
                            <ListItemText className={classes.sumListItemText} primary="Total" secondary={totalFormattted} />
                        </Grid>
                        {!!cart.extraFields.length &&
                            <form ref={this.extraFieldsFormRef}>
                                {cart.extraFields.map(field => (
                                    <TextField
                                        select={field.type == 'select'}
                                        className={classes.marginAbove}
                                        key={field.label}
                                        label={field.label}
                                        name={field.name}
                                        defaultValue=""
                                        variant="outlined"
                                        required={field.required}
                                        fullWidth
                                    >
                                        {field.options?.map(option => (
                                            <MenuItem key={option} value={option}>{option}</MenuItem>
                                        ))}
                                    </TextField>
                                ))}
                            </form>
                        }
                        <TextField
                            className={classes.marginAbove}
                            label="Note to clinic (optional)"
                            variant="outlined"
                            fullWidth
                            multiline
                            onInput={(e) => this.handleNoteChange(e)}
                        />
                        <CardActions className={classes.cardActions}>
                            <Button
                                variant="contained"
                                color="secondary"
                                endIcon={<RemoveShoppingCartIcon />}
                                onClick={this.handleEmptyCart}
                            >
                                Empty Cart
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<ShoppingCartIcon />}
                                disabled={!this.isSubmittable()}
                                onClick={this.handleSubmitOrder}
                            >
                                Submit Order
                            </Button>
                        </CardActions>
                    </Card>
                }

                <Dialog open={submitting}>
                    <Typography className={classes.dialogText}>Submitting order, please wait...</Typography>
                </Dialog>
            </Container>
        )
    }
}

export default withAppContext(withRouter(withStyles(styles, { withTheme: true })(Cart)))
